import { NCmsComponentListing } from '../../../component/listing/cms-component-listing.interface';

export namespace NCmsBlogComponentListing {
    export const ID = 'blog-listing';

    export interface IData extends NCmsComponentListing.IData {
        heading?: string;
        text_style?: string;
        color?: string;
    }
}
